var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.55469 5.44508L3.88778 0.778175C3.02863 -0.0809789 1.63567 -0.0809786 0.776513 0.778174C-0.0826407 1.63733 -0.082641 3.03029 0.776513 3.88944L5.44342 8.55635L0.776512 13.2233C-0.0826413 14.0824 -0.08264 15.4754 0.776513 16.3345C1.63567 17.1937 3.02863 17.1937 3.88778 16.3345L8.55469 11.6676L13.2216 16.3345C14.0807 17.1937 15.4737 17.1937 16.3329 16.3345C17.192 15.4754 17.192 14.0824 16.3329 13.2233L11.666 8.55635L16.3329 3.88944C17.192 3.03029 17.192 1.63733 16.3329 0.778174C15.4737 -0.0809786 14.0807 -0.0809789 13.2216 0.778175L8.55469 5.44508Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.bf7030595af26c45f020a0ab244cef05.svg";
export { ForwardRef as ReactComponent };